import { Component } from "react";
import Autenticador from "../../servicios/Autenticador";

class autenticacion extends Component {
  async componentDidMount() {
    document.body.classList.add("bg-gradient-primary");

    await Autenticador.IniciarSesion();
  }

  render() {
    return (
      <div className="d-flex justify-content-center align-items-center m-5">
        <div
          className="alert alert-secondary text-center shadow-lg"
          role="alert"
        >
          <div
            className="spinner-border spinner-border-sm text-primary mr-2"
            role="status"
          />
          Autenticando usuario...
        </div>
      </div>
    );
  }
}

export default autenticacion;
